// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const BrowserReplaceTypeSchema = z.enum(['STRING','REGEX','FUNCTION'] as const);

export type BrowserReplaceTypeType = `${z.infer<typeof BrowserReplaceTypeSchema>}`

export default BrowserReplaceTypeSchema;
